import React, { Component } from 'react';
import './alert.css';

class Alert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alertsArray: [],
            currentLength: 0,
        };
    }

    componentWillReceiveProps(nextProps) {
        const newAlerts = nextProps.alerts;
        if ( newAlerts.length > this.state.currentLength ) {
            this.setState({ alertsArray: newAlerts }, () => {
                this.setState({ currentLength: this.state.alertsArray.length });
            });
        }
    }

    returnAlerts = (array) => {
        if (array.length > 0 ) {
            return array.map(( { type = 'success', title = 'título', message = 'messagem', duration = 3000 }, i ) => {
                if ( i === this.state.currentLength - 1 ) {
                    return (
                        <div key={ i } className={`alert ${ type }`} style={{ animationDuration: `${duration / 1000}s` }}>
                            <section className='title'>
                                <i className={`fa ${ type === 'success' ? 'fa-check' : 'fa-close'}`} />
                                <div>{ title ? title : type === 'success' ? 'Sucesso' : 'Erro!'}</div>
                            </section>
                            <p>{ message ? message : type === 'success' ? 'Operação conclúida com sucesso!' : 'Operação não conclúida'}</p>
                        </div>
                    );
                }
                return true;
            });
        }
    };

    render() {
        const { alertsArray } = this.state;
        let Alert = this.returnAlerts( alertsArray );
        return (
            <div className='alerts-wrapper'>
                { Alert }
            </div>
        );
    }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/alerts/alert.js